import { IS_TAURI } from '@/util/platform'

/**
 * Safari does not allow opening a pop-up not in response to a user interaction.
 * It can, however, set the location after opening.
 *
 * Cordova's InAppBrowser cannot change the location after opening, but can open a pop-up at any time.
 *
 * Tauri's iOS WKWebView routes `window.open` to a native SFSafariViewController via a UIDelegate
 * (see PopupHandler.mm), so it must receive the URL up front like the Cordova path.
 *
 * `noopener` does the same for a different reason: it makes `window.open` return null by spec, so
 * there is no handle to set a location on and the two-step open would silently do nothing.
 *
 * @param url
 * @param target
 * @param features
 */
export async function openWindow(
    url: Promise<string>,
    target?: string,
    features?: string
): Promise<WindowProxy | null> {
    if ('cordova' in global || IS_TAURI || features?.includes('noopener')) {
        return window.open(await url, target, features)
    } else {
        const popup = window.open(undefined, target, features)
        if (popup) popup.location = await url
        return popup
    }
}
